/**
 * @generated SignedSource<<e28aaf5b166e89428cec1a7c852a1d60>>
 * @relayHash 847afa9df9ce15669780b96e7411cae2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9056f69c8a2ffc538b139832368172983c1a0e88a4743d06f797d2e269997d1d

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type PolicyConflictsIndexStepQuery$variables = {
  policyId: string;
};
export type PolicyConflictsIndexStepQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PolicyConflictsIndexStep_query">;
};
export type PolicyConflictsIndexStepQuery = {
  response: PolicyConflictsIndexStepQuery$data;
  variables: PolicyConflictsIndexStepQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "policyId"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "concreteType": "JiraProjectPolicyRuleViolation",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "domain"
      },
      {
        "kind": "ScalarField",
        "name": "entityId"
      },
      {
        "kind": "ScalarField",
        "name": "entityName"
      },
      {
        "kind": "ScalarField",
        "name": "entityType"
      },
      {
        "kind": "ScalarField",
        "name": "message"
      },
      {
        "concreteType": "JiraProjectPolicyRemediationData",
        "kind": "LinkedField",
        "name": "remediation",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraRemediationProgress",
            "kind": "LinkedField",
            "name": "progress",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "status"
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "supportedRemediations"
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "ruleId"
      },
      {
        "kind": "ScalarField",
        "name": "ruleTypeId"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "PolicyConflictsIndexStepQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "policyId",
            "variableName": "policyId"
          }
        ],
        "kind": "FragmentSpread",
        "name": "PolicyConflictsIndexStep_query"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PolicyConflictsIndexStepQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "policyId"
              }
            ],
            "concreteType": "JiraProjectPolicy",
            "kind": "LinkedField",
            "name": "projectPolicy",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 20
                  }
                ],
                "concreteType": "JiraProjectPolicyAssociationConnection",
                "kind": "LinkedField",
                "name": "associatedProjects",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "totalCount"
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  },
                  {
                    "concreteType": "JiraProjectPolicyAssociation",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      {
                        "alias": "fieldViolations",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "filter",
                            "value": {
                              "domains": "field"
                            }
                          }
                        ],
                        "concreteType": "JiraProjectPolicyRuleViolationConnection",
                        "kind": "LinkedField",
                        "name": "ruleViolations",
                        "plural": false,
                        "selections": (v2/*: any*/),
                        "storageKey": "ruleViolations(filter:{\"domains\":\"field\"})"
                      },
                      {
                        "alias": "statusViolations",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "filter",
                            "value": {
                              "domains": "workflow"
                            }
                          }
                        ],
                        "concreteType": "JiraProjectPolicyRuleViolationConnection",
                        "kind": "LinkedField",
                        "name": "ruleViolations",
                        "plural": false,
                        "selections": (v2/*: any*/),
                        "storageKey": "ruleViolations(filter:{\"domains\":\"workflow\"})"
                      },
                      {
                        "concreteType": "JiraProject",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "name"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "key"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "projectType"
                          },
                          {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "small"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": "associatedProjects(first:20)"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "9056f69c8a2ffc538b139832368172983c1a0e88a4743d06f797d2e269997d1d",
    "metadata": {},
    "name": "PolicyConflictsIndexStepQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1a171bc734e87219bff936a1e2246727";

export default node;
